import { Range } from "@pdfking/tfunc"

import type { AgendaDesign, AgendaPageKind } from "#internal"

// Page `page` given to `kind`
const claim = (page: number, kind: AgendaPageKind): [number, AgendaPageKind] => [page, kind]

/** The pages an agenda of `design` gives a part of its own, before its days,
 * by number: the year's months a page each from the 2nd when it has them, a
 * dated one's next year on the page before the title, the year planned on
 * two from its `planner`, the owner's details on the 1st, the contacts, and
 * the title. No two parts may claim the same page. */
export const AgendaFixedPages = (design: AgendaDesign): [number, AgendaPageKind][] => [
  ...(design.months ? [...Range(1, 12)] : []).map(month =>
    claim(month + 1, { enum: "month", month })
  ),
  ...(design.dated ? [claim(design.title - 1, { enum: "next_year" })] : []),
  ...(design.planner ? [0, 1] : []).map(half =>
    claim(design.planner + half, { enum: "planner", half })
  ),
  claim(1, { enum: "info" }),
  ...(design.contacts ? [claim(design.contacts, { enum: "contacts" })] : []),
  claim(design.title, { enum: "title" }),
]
